import { render, staticRenderFns } from "./myBlessing.vue?vue&type=template&id=8eb89bd6&scoped=true"
import script from "./myBlessing.vue?vue&type=script&lang=js"
export * from "./myBlessing.vue?vue&type=script&lang=js"
import style0 from "./myBlessing.vue?vue&type=style&index=0&id=8eb89bd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eb89bd6",
  null
  
)

export default component.exports